import actionTypes from 'constants/actionTypes'

interface CreatingState {
  ids: string[]
  isCreating: boolean
}

interface CreatingAction {
  type: string
  payload?: {
    ids?: string[]
  }
}

const initialState: CreatingState = {
  ids: [],
  isCreating: false,
}

const focus = (state: CreatingState = initialState, action: CreatingAction): CreatingState => {
  switch (action.type) {
    case actionTypes.GRAPH.EDGE_CREATION.START:
      return {
        ids: action.payload?.ids ?? [],
        isCreating: true
      }
    case actionTypes.GRAPH.EDGE_CREATION.STOP:
      return {
        ids: [],
        isCreating: false
      }
    default:
      return state
  }
}

export default focus
